import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { BsPlusCircle } from "react-icons/bs";
import "./Customer.css";
import AddCustomer from "./Component/AddCustomer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import EditCustomer from "./Component/EditCustomer";
import { Table } from "antd";
import MainLayout from "../../../../layouts/MainLayout";
import { getCustomerData } from "../../../../redux/actions/employeeActions";
import Loader from "../../../../components/Loader";
const Customer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [query, setQuery] = useState("");
  const getCustomerDetails = useSelector((state) => state.employeeData?.customerData);
  const isDataLoading = useSelector((state) => state.employeeData?.loading);
  const [filterCustomer, setFilterCustomer] = useState(getCustomerDetails);
  const [customerData, setCustomerData] = useState();
  const dispatch = useDispatch();
  const handleClick = () => {
    setModalOpen(true);
  };
  const columns = [
    {
      title: "SN.",
      dataIndex: "sn",
      key: "sn",
      render: (text, record, index) => index + 1,
      width: 60,
      fixed: "left",
    },
    {
      title: "CUSTOMER NAME",
      dataIndex: "customer_name",
      width: 200,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "COMPANY NAME",
      dataIndex: "company_name",
      width: 200,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },

    // {
    //   title: "Email",
    //   dataIndex: "email_addresses",
    //   width: 300,
    //   render: (_,rowData,index) => {
    //     let emailArray = [];
    //     try {
    //       emailArray = JSON.parse(rowData.email_addresses);
    //     } catch (e) {
    //       emailArray = [];
    //     }

    //     if (emailArray.length > 0) {
    //       return emailArray.join(" , ");
    //     } else {
    //       return "No Emails";
    //     }
    //   },
    // },
    {
      title: "EMAIL",
      dataIndex: "email_addresses",
      width: 300,
      render: (_, rowData, index) => {
        let emailArray = [];
        try {
          emailArray = JSON.parse(rowData.email_addresses);
        } catch (e) {
          emailArray = [];
        }

        const text = emailArray.length > 0 ? emailArray.join(" , ") : "No Emails";

        return (
          <span
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              display: "block", // Ensures it takes full width
              overflowWrap: "break-word",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "PHONE NUMBER",
      dataIndex: "work_phone",
      width: 200,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "MOBILE",
      dataIndex: "mobile",
      width: 200,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "COUNTRY",
      dataIndex: "country",
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "CURRENCY",
      dataIndex: "currency",
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "STATE",
      dataIndex: "state",
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "CITY",
      dataIndex: "city",
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "ADDRESS",
      dataIndex: "address",
      width: 250,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "PINCODE",
      dataIndex: "pincode",
      width: 100,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "ACTION",
      filtering: false,
      width: 100,
      render: (rowData) => (
        <div>
          <button
            className="action-button"
            onClick={() => {
              editcustomerDetails(rowData);
            }}
          >
            <FaEdit />
          </button>
        </div>
      ),
    },
  ];
  const editcustomerDetails = (data) => {
    setCustomerData(data);
    setEditModalOpen(true);
  };
  useEffect(() => {
    dispatch(getCustomerData())
  }, []);

 
  useEffect(() => {
    setFilterCustomer(getCustomerDetails);
  }, [getCustomerDetails]);


  const handleInputChange = (event) => {
    setQuery(event.target.value);
    updateFilteredCategories(event.target.value);
  };
  const updateFilteredCategories = (searchTerm) => {
    const lowerCaseQuery = searchTerm.trim().toLowerCase();

    const filteredItems = getCustomerDetails.filter((item) => {
      return (
        item.company_name.toLowerCase().includes(lowerCaseQuery) ||
        item.customer_name.toLowerCase().includes(lowerCaseQuery)
      );
    });

    setFilterCustomer(filteredItems);
  };
  return (
    <MainLayout>
      <div className="page-wrapper">
        {
          isDataLoading &&
          <Loader style={{ height: "100" }} />
        }
        <div className="content">
          <div className="mainDivCustomer">
            <h1
              style={{
                fontWeight: "700",
                fontSize: 20,
                color: "black",
                padding: 15,
                textAlign: "left",
              }}
            >
              All Customers
            </h1>
            <div className="mainDivCustomer2">
              <div className="card-containerCustomer">
                <div className="d-flex justify-content-between align-items-center pb-2">

                  <div className="customersearchBar-wrapper w-25 d-flex justify-content-between align-items-center">
                    <input
                      type="text"
                      id="search-query"
                      name="query"
                      value={query}
                      onChange={handleInputChange}
                      placeholder="Search..."
                      autoComplete="current-query"
                      className="customersearchBar-input"
                    />
                    {/* <FaSearch className="search-icon" /> */}
                  </div>

                  <div className="button-customercontainer">
                    <button className="btn btn-primary d-flex gap-1 align-items-center" onClick={handleClick}>
                      <BsPlusCircle style={{ marginRight: "10px" }} />
                      New Customer
                    </button>
                  </div>
                </div>

                <Table
                  dataSource={filterCustomer}
                  className="dotted-border-table"
                  columns={columns}
                  pagination={{ pageSize: 10, position: ["bottomRight"] }}
                  rowClassName={() => "custom-row"}
                  bordered={false}
                  // style={{ tableLayout: "auto" }}
                  tableLayout="fixed"
                  rowKey="key"
                  scroll={{ x: 1000 }} // Ensures proper scrolling behavior
                  locale={{
                    emptyText: (
                      <div className="custom-no-data">No Employee Data Found</div>
                    ),
                  }}
                />
              </div>
            </div>
            <AddCustomer open={modalOpen} onClose={() => setModalOpen(false)} />
            <EditCustomer
              open={editModalOpen}
              onClose={() => setEditModalOpen(false)}
              customerDetails={customerData}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Customer;
